import { render, staticRenderFns } from "./FreeFlowers.vue?vue&type=template&id=2e930ab8&scoped=true&"
import script from "./FreeFlowers.vue?vue&type=script&lang=js&"
export * from "./FreeFlowers.vue?vue&type=script&lang=js&"
import style0 from "./FreeFlowers.vue?vue&type=style&index=0&id=2e930ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e930ab8",
  null
  
)

export default component.exports